import { homeApi } from "@/api/template";

const state = {
  channelId: "", //渠道id
  currentEditComponent: "", //当前正在编辑的组件名称
  currentId: "1", //当前编辑的组建的id（组件的唯一标示）
  items: [], //组件预览区全部组件存放
  switch: true,
  titleTpl: {
    //存储标题组件的数据
    titleName: "", //页面标题
    autoHidden: 0, //0不隐藏，1隐藏
    backgroundShowWay: 0, //背景展示方式 0背景颜色1图片2默认颜色
    fontColor: "#666", //初始化颜色，需要和产品定一下
    backgroundColor: "", //背景颜色
    isShareShow: 0, //0隐藏分享1显示分享
    isSearchShow: 0
  },
  headerSearch: {
    backgroundShowWay: 0, //背景展示方式 0背景颜色1图片2默认颜色
    backgroundColor: "", //背景颜色
    backgroundImage: "" //背景图片
  },
  footerTpl: {
    backgroundShowWay: 0,
    backgroundColor: "",
    backgroundImage: "",
    iconDTOS: []
  },
  shortVideo: {
    videoSrc: "",
    autoplay: true,
    loop: true,
    posterSrc: "",
    height: ""
  },
  carousel: {
    imageLinkVOS: [],
    dtoFlag: false,
    autoFlag: false,
    beforeMargin: 0,
    afterMargin: 0,
    margin: 0,
    circularFlag: true
  },
  singleImg: {
    imageLinkVOS: []
  },
  rowScrollImg: {
    imageLinkVOS: []
  },
  oneRowTwoImg: {
    imageLinkVOS: []
  },
  oneRowThreeImg: {
    imageLinkVOS: []
  },
  oneBigTwoLittle: {
    imageLinkVOS: [
      {
        image: "", //图片地址
        linkType: 1,
        linkValue: "",
        sortNo: 0
      },
      {
        image: "", //图片地址
        linkType: 1,
        linkValue: "",
        sortNo: 1
      },
      {
        image: "", //图片地址
        linkType: 1,
        linkValue: "",
        sortNo: 2
      }
    ]
  },
  iconNav: {
    iconCount: 1000,
    fontColor: "", //初始字体颜色，未定
    hoverColor:"#000",
    shadowColor:"#000",
    backgroundColor: "",
    backgroundShowWay: "",
    backgroundImage: "",
    imageLinkVOS: []
  },
  styleSet: {
    lineType: 0,
    height: 1,
    color: ""
  },
  headLine: {
    backgroundImage: "",
    logoImage: "",
    fontColor: "",
    wordsLinkVOS: []
  },
  textTpl: {
    text: "",
    fontSize: 12,
    fontColor: "",
    backgroundColor: "",
    typeSet: "", //文字排版
    linkType: "",
    linkValue: "",
    moreFlag:false
  },
  multiTextTpl: {
    text: "",
    fontSize: 12,
    fontColor: "",
    backgroundColor: "",
    typeSet: "", //文字排版
    linkType: "",
    linkValue: ""
  },
  backToTop: {
    iconUrl: ""
  },
  popup: {
    image: "", //图片地址
    linkType: 1,
    linkValue: "",
    startTime: "",
    endTime: "",
    timesControl: ""
  },
  oneColumnGoods: {
    showMarketPrice: 0, //市场价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showNumberOfComments: 0, //评价是否展示
    showSalesVolume: 1, //销量是否展示
    showIntegralRatio: 1, //积分折扣是否展示
    itemVOS: [], //商品集合
    overrideSort: "1" // 商品排序：1-手动 2-总销量从高到低
  },
  twoColumnGoods: {
    showGoodsName: 1, //标题是否展示
    showNumberOfComments: 1, //评价是否展示
    showMarketPrice: 1, //市场价是否展示
    showSalesVolume: 1, //销量是否展示
    showSellingPrice: 0, //售价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showIntegralRatio: 1, //积分折扣是否展示
    itemVOS: [], //商品集合
    showBorder: false,
    backgroundColor: "#f5f5f5",
    overrideSort: "1" // 商品排序：1-手动 2-总销量从高到低
  },
  slidingGoods: {
    showSellingPrice: 1, //售价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showMarketPrice: 1, //市场价是否展示
    showGoodsName: 1, //标题是否展示
    showIntegralRatio: 1, //积分折扣是否展示
    itemVOS: [], //商品集合
    overrideSort: "1" // 商品排序：1-手动 2-总销量从高到低
  },
  threeColumnGoods: {
    showGoodsName: 1, //标题是否展示
    showNumberOfComments: 0, //评价是否展示
    showSalesVolume: 0, //销量是否展示
    showSellingPrice: 1, //售价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showIntegralRatio: 1, //积分折扣是否展示
    itemVOS: [], //商品集合
    showBorder: false,
    backgroundColor: "#f5f5f5",
    overrideSort: "1" // 商品排序：1-手动 2-总销量从高到低
  },
  fourColumnGoods: {
    showGoodsName: 1, //标题是否展示
    showNumberOfComments: 0, //评价是否展示
    showSalesVolume: 0, //销量是否展示
    showSellingPrice: 1, //售价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showIntegralRatio: 1, //积分折扣是否展示
    itemVOS: [], //商品集合
    showBorder: false,
    backgroundColor: "#f5f5f5",
    overrideSort: "1" // 商品排序：1-手动 2-总销量从高到低
  },
  aiGoods: {
    showGoodsName: 1, //标题是否展示
    showNumberOfComments: 0, //评价是否展示
    showSalesVolume: 0, //销量是否展示
    showSellingPrice: 1, //售价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showIntegralRatio: 1, //积分折扣是否展示
    itemVOS: [], //商品集合
    showBorder: false,
    backgroundColor: "#f5f5f5",
    overrideSort: "1" // 商品排序：1-手动 2-总销量从高到低
  },
  tab: {
    backgroundShowWay: "",
    backgroundColor: "",
    backgroundImage: "",
    optionColor: "",
    selectedColor: "",
    foldSwitch: "",
    tabBackgroundImg: "",
    tabIcon: "",
    tabDTOS: [
      {
        name: "",
        sortNo: "",
        pageUrl: "",
        componentId: ""
      }
    ]
  },
  lift: {
    backgroundShowWay: "",
    backgroundColor: "",
    backgroundImage: "",
    defaultTabColor: "",
    selectedTabColor: "",
    tabDTOS: [
      {
        name: "",
        sortNo: "",
        pageUrl: "",
        componentId: ""
      }
    ]
  },
  oneColumnCoupon: {
    notReceiveImage: "", //未领取图片
    receivedImage: "", //已领取
    broughtOutImage: "", //已领完
    backgroundColor: "",
    fontColor: "",
    itemVOS: [],
    showWords: "1" // 是否展示金额 文字等信息 0为不展示 1为展示
  },
  twoColumnCoupon: {
    notReceiveImage: "", //未领取图片
    receivedImage: "", //已领取
    broughtOutImage: "", //已领完
    backgroundColor: "",
    fontColor: "",
    itemVOS: [],
    showWords: "1" // 是否展示金额 文字等信息 0为不展示 1为展示
  },
  threeColumnCoupon: {
    notReceiveImage: "", //未领取图片
    receivedImage: "", //已领取
    broughtOutImage: "", //已领完
    backgroundColor: "",
    fontColor: "",
    itemVOS: [],
    showWords: "1" // 是否展示金额 文字等信息 0为不展示 1为展示
  },
  slidingCoupon: {
    notReceiveImage: "", //未领取图片
    receivedImage: "", //已领取
    broughtOutImage: "", //已领完
    backgroundColor: "",
    fontColor: "",
    itemVOS: []
  },
  secKill: {},
  imageTextPreciseSelect: {
    showSummary: 1, //文章摘要是否展示
    showCommentsNum: 1, //评论数量是否展示
    showReadNum: 1, //已读数量是否展示
    showPriseNum: 1, //点赞数是否展示
    showAuthor: 1, //作者是否展示
    showTestNum: 1,
    backgroundColor: "#f00", //组件背景色
    itemVOS: [] //内容列表集合
  },
  evaluationPreciseSelect: {
    //
    showSummary: 1, //评测摘要是否展示
    showCommentsNum: 1, //评测评论数量是否展示
    showReadNum: 1, //已读数量是否展示
    showPriseNum: 1, //点赞数是否展示
    showAuthor: 1, //作者是否展示
    showTestNum: 1,
    backgroundColor: "#f00", //组件背景色
    itemVOS: [] //评测内容列表集合
  },
  imageTextAutoSelect: {
    showSummary: 1, //文章摘要是否展示
    showCommentsNum: 1, //评论数量是否展示
    showReadNum: 1, //已读数量是否展示
    showPriseNum: 1, //点赞数是否展示
    showAuthor: 1, //作者是否展示
    showTestNum: 1,
    backgroundColor: "#f00", //组件背景色
    contentIds: {
      authors: [], //作者|来源
      specials: [], //专栏
      topics: [], //栏目
      tags: [], //标签
      startTime: "", //更新开始时间
      endTime: "", //更相信结束时间
      sortCond: "lastModifiedTime"
    } //内容爬取规则
  },
  oneColumnCollage: {
    showSeveralPeopleCollage: 1, // 几人团是否展示
    showMarketPrice: 1, //原价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showSalesVolume: 1, //销量是否展示
    showCollageBtn: 1, // 去拼团按钮是否展示
    showIntegralRatio: 0, //积分折扣是否展示
    backgroundColor: "#f5f5f5",
    itemVOS: [], //商品集合
    overrideSort: 1 // 商品排序：1-手动 2-总销量从高到低
  },
  twoColumnCollage: {
    showSeveralPeopleCollage: 1, // 几人团是否展示
    showMarketPrice: 1, //原价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showSalesVolume: 1, //销量是否展示
    showCollageBtn: 1, // 去拼团按钮是否展示
    showIntegralRatio: 0, //积分折扣是否展示
    backgroundColor: "#f5f5f5",
    itemVOS: [], //商品集合
    overrideSort: 1 // 商品排序：1-手动 2-总销量从高到低
  },
  threeColumnCollage: {
    showSeveralPeopleCollage: 1, // 几人团是否展示
    showMarketPrice: 1, //原价是否展示          1.以下所有涉及布尔值的字段 0 = false(隐藏);1 = true（显示）
    showSalesVolume: 1, //销量是否展示
    showCollageBtn: 1, // 去拼团按钮是否展示
    showIntegralRatio: 0, //积分折扣是否展示
    backgroundColor: "#f5f5f5",
    itemVOS: [], //商品集合
    overrideSort: 1 // 商品排序：1-手动 2-总销量从高到低
  },
  memberCulling: {
    title: "会员精选",
    subTitle: "精选妈星好物",
    titleColor: "#000",
    subTitleColor: "#FF9900",
    items: [],
    linkType: "",
    linkValue: ""
  },
  boutique: {
    labelDefaultColor: "#ffffff",
    labelSelectedColor: "#000",
    labels: [],
    aiGoodsConfig: {
      marketingTypeValues: [],
      marketingFilterType: 0,
      goodsNum: ""
    }
  },
  activityJigsawEdit: [
    // 拼团模块
    {
      title: "PLUS尊享", // 标题
      titleColor: "#F0A600", // 标题颜色
      subtitle: "1.3万人正在拼", // 副标题
      subtitleColor: "#999999", // 副标题颜色
      linkType: 1, // 链接类型
      linkValue: "", // 链接地址
      items: [] // 拼团商品list数据
    },
    // 大牌推荐模块
    {
      title: "排行榜", // 标题
      titleColor: "#333333", // 标题颜色
      subtitle: "每天10点更新", // 副标题
      subtitleColor: "#999999", // 副标题颜色
      linkType: 1, // 链接类型
      linkValue: "", // 链接地址
      items: [] // 拼团商品list数据
    },
    {
      title: "星礼卡", // 标题
      titleColor: "#333333", // 标题颜色
      subtitle: "每天10点更新", // 副标题
      subtitleColor: "#999999", // 副标题颜色
      linkType: 1, // 链接类型
      linkValue: "", // 链接地址
      items: [] // 商品list数据
    },
    {
      title: "每日上新", // 标题
      titleColor: "#333333", // 标题颜色
      subtitle: "剁手必看指南", // 副标题
      subtitleColor: "#999999", // 副标题颜色
      linkType: 1, // 链接类型
      linkValue: "", // 链接地址
      items: [] // 商品list数据
    }
  ],
  titleNav: {
    backgroundColor: "#ffffff",
    backgroundImage: "",
    labelDefaultColor: "#ffffff",
    labelSelectedColor: "#ffffff",
    labels: []
  },
  titleConfig: {
    kfDefaultImage: "",
    kfCeilingImage: "",
    siginDefaultImage: "",
    siginCeilingImage: "",
    messageDefaultImage: "",
    messageCeilingImage: "",
    title: {
      type: "0",
      defaultColorConfig: [],
      ceilingColorConfig: "#fff",
      imageConfig: ""
    },
    swiper: {
      type: "0",
      colorConfig: [],
      imageConfig: ""
    }
  },
  newUser: {},
  seckillActivity: {},
  slideVideo: {
    imageUrl: "",
    videoList: [
      {
        videoSrc: "",
        posterSrc: "",
        width: "",
        height: ""
      }
    ]
  }
};
const getters = {
  channelId: state => state.channelId,
  currentEditComponent: state => state.currentEditComponent,
  titleTpl: state => state.titleTpl,
  currentId: state => state.currentId,
  headerSearch: state => state.headerSearch,
  footerTpl: state => state.footerTpl,
  carousel: state => state.carousel,
  singleImg: state => state.singleImg,
  rowScrollImg: state => state.rowScrollImg,
  oneRowTwoImg: state => state.oneRowTwoImg,
  oneRowThreeImg: state => state.oneRowThreeImg,
  oneBigTwoLittle: state => state.oneBigTwoLittle,
  iconNav: state => state.iconNav,
  styleSet: state => state.styleSet,
  oneColumnGoods: state => state.oneColumnGoods,
  twoColumnGoods: state => state.twoColumnGoods,
  slidingGoods: state => state.slidingGoods,
  threeColumnGoods: state => state.threeColumnGoods,
  fourColumnGoods: state => state.fourColumnGoods,
  aiGoods: state => state.aiGoods,
  tab: state => state.tab,
  lift: state => state.lift,
  headLine: state => state.headLine,
  textTpl: state => state.textTpl,
  multiTextTpl: state => state.multiTextTpl,
  backToTop: state => state.backToTop,
  items: state => state.items,
  oneColumnCoupon: state => state.oneColumnCoupon,
  twoColumnCoupon: state => state.twoColumnCoupon,
  threeColumnCoupon: state => state.threeColumnCoupon,
  slidingCoupon: state => state.slidingCoupon,
  secKill: state => state.secKill,
  popup: state => state.popup,
  imageTextPreciseSelect: state => state.imageTextPreciseSelect,
  imageTextAutoSelect: state => state.imageTextAutoSelect,
  evaluationPreciseSelect: state => state.evaluationPreciseSelect,
  oneColumnCollage: state => state.oneColumnCollage,
  twoColumnCollage: state => state.twoColumnCollage,
  threeColumnCollage: state => state.threeColumnCollage,
  memberCulling: state => state.threeColumnCollage,
  activityJigsaw: state => state.activityJigsaw,
  boutique: state => state.boutique,
  titleNav: state => state.titleNav,
  titleConfig: state => state.titleConfig,
  newUser: state => state.newUser,
  seckillActivity: state => state.seckillActivity,
  shortVideo: state => state.shortVideo,
  slideVideo: state => state.slideVideo
};
const actions = {
  // getRecommendCart({ commit, state }) {
  //   homeApi.appHomePage(state.ids.cart).then(res => {
  //     return new Promise((resolve, reject) => {
  //       resolve();
  //       commit("getCartData", res.data);
  //     });
  //   });
  // }
};

const mutations = {
  channelId: (state, data) => {
    state.channelId = data;
  },
  currentEditComponent: (state, data) => {
    state.currentEditComponent = data;
  },
  titleTpl: (state, data) => {
    state.titleTpl = data;
  },
  currentId: (state, data) => {
    state.currentId = data;
  },
  headerSearch: (state, data) => {
    state.headerSearch = data;
  },
  footerTpl: (state, data) => {
    state.footerTpl = data;
  },
  carousel: (state, data) => {
    state.carousel = data;
  },
  singleImg: (state, data) => {
    state.singleImg = data;
  },
  rowScrollImg: (state, data) => {
    state.rowScrollImg = data;
  },
  oneRowTwoImg: (state, data) => {
    state.oneRowTwoImg = data;
  },
  oneRowThreeImg: (state, data) => {
    state.oneRowThreeImg = data;
  },
  oneBigTwoLittle: (state, data) => {
    state.oneBigTwoLittle = data;
  },
  iconNav: (state, data) => {
    state.iconNav = data;
  },
  styleSet: (state, data) => {
    state.styleSet = data;
  },
  oneColumnGoods: (state, data) => {
    state.oneColumnGoods = data;
  },
  twoColumnGoods: (state, data) => {
    state.twoColumnGoods = data;
  },
  slidingGoods: (state, data) => {
    state.slidingGoods = data;
  },
  threeColumnGoods: (state, data) => {
    state.threeColumnGoods = data;
  },
  fourColumnGoods: (state, data) => {
    state.fourColumnGoods = data;
  },
  aiGoods: (state, data) => {
    state.aiGoods = data;
  },
  tab: (state, data) => {
    state.tab = data;
  },
  lift: (state, data) => {
    state.lift = data;
  },
  headLine: (state, data) => {
    state.headLine = data;
  },
  textTpl: (state, data) => {
    state.textTpl = data;
  },
  multiTextTpl: (state, data) => {
    state.multiTextTpl = data;
  },
  backToTop: (state, data) => {
    state.backToTop = data;
  },
  items: (state, data) => {
    state.items = data;
  },
  oneColumnCoupon: (state, data) => {
    state.oneColumnCoupon = data;
  },
  twoColumnCoupon: (state, data) => {
    state.twoColumnCoupon = data;
  },
  threeColumnCoupon: (state, data) => {
    state.threeColumnCoupon = data;
  },
  slidingCoupon: (state, data) => {
    state.slidingCoupon = data;
  },
  secKill: (state, data) => {
    state.secKill = data;
  },
  popup: (state, data) => {
    state.popup = data;
  },
  imageTextPreciseSelect: (state, data) => {
    state.imageTextPreciseSelect = data;
  },
  imageTextAutoSelect: (state, data) => {
    state.imageTextAutoSelect = data;
  },
  evaluationPreciseSelect: (state, data) => {
    state.evaluationPreciseSelect = data;
  },
  oneColumnCollage: (state, data) => {
    state.oneColumnCollage = data;
  },
  threeColumnCollage: (state, data) => {
    state.threeColumnCollage = data;
  },
  twoColumnCollage: (state, data) => {
    state.twoColumnCollage = data;
  },
  memberCulling: (state, data) => {
    state.threeColumnCollage = data;
  },
  activityJigsaw: (state, data) => {
    state.activityJigsaw = data;
  },
  boutique: (state, data) => {
    state.boutique = data;
  },
  titleNav: (state, data) => {
    state.titleNav = data;
  },
  titleConfig: (state, data) => {
    state.titleConfig = data;
  },
  newUser: (state, data) => {
    state.newUser = data;
  },
  seckillActivity: (state, data) => {
    state.seckillActivity = data;
  },
  shortVideo: (state, data) => {
    state.shortVideo = data;
  },
  slideVideo: (state, data) => {
    state.slideVideo = data;
  }
};
export default {
  state,
  mutations,
  actions,
  getters
};
